import React, {useEffect, useState} from "react";
import DatePicker from "react-datepicker";
import InputLabel from "@mui/material/InputLabel";
import {FormControl} from "@mui/material";
import {
  dateToStringFormat,
  getFechaToCalendar, validArray,
} from "../../util/functions";
import {isEmpty, isFunction, isObject} from "../../util/is";
import {Controller, useController, useWatch} from "react-hook-form";
import "react-datepicker/dist/react-datepicker.css";
import Tooltip from "@mui/material/Tooltip";
import { getMonth, getYear } from 'date-fns';
import range from "lodash/range";
import {Colors} from "../../assets/colors/Colors";
import Emitter from "../../EventEmitter/EventEmitter";
const defaultValue = new Date();



const years = range(1990, 3000, 1);
const months = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembrer",
  "Octubre",
  "Noviembre",
  "Deciembre",
];

const RenderCustomHeader = ({
  date,
  changeYear,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  showLastDate,
  identificador,
  controller
}) => {

  const handleLastDate = () => {

    changeYear('9999')
    changeMonth(11);

    if(controller){
      Emitter.emit(`handleSelectLastDateController${identificador}`, getFechaToCalendar('9999-12-31'));
    }
    else{
      Emitter.emit(`handleSelectLastDateNoController${identificador}`, getFechaToCalendar('9999-12-31'));
    }

  }

  const handleCurrentDate = () => {

    changeYear(getYear(new Date()));
    changeMonth(months.indexOf(months[getMonth(new Date())]));

    if(controller){
      Emitter.emit(`handleSelectLastDateController${identificador}`, getFechaToCalendar());
    }
    else{
      Emitter.emit(`handleSelectLastDateNoController${identificador}`, getFechaToCalendar());
    }

  }

  return (<div style={{margin: 10}}>
    <div
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <button style={{backgroundColor: '#216ba5', borderRadius: 3, color: Colors.WHITE}} className="mr-2" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
        {"<"}
      </button>
      <select
        className="mr-1"
        value={getYear(date)}
        onChange={({ target: { value } }) => changeYear(value)}
      >
        {years.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
        <option key={`9999`} value={`9999`}>
          {`9999`}
        </option>
      </select>

      <select
        className="ml-1"
        value={months[getMonth(date)]}
        onChange={({ target: { value } }) =>
          changeMonth(months.indexOf(value))
        }
      >
        {months.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>

      <button style={{backgroundColor: '#216ba5', borderRadius: 3, color: Colors.WHITE}} className="ml-2" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
        {">"}
      </button>
    </div>
    <div className="d-flex align-items-center">
      {
        false &&
        <button style={{backgroundColor: '#216ba5', borderRadius: 3, color: Colors.WHITE}} className={showLastDate ? "mt-2 mr-1 w-100" : "mt-2 w-100"} onClick={() => handleCurrentDate()} disabled={nextMonthButtonDisabled}>
          {"Fecha actual"}
        </button>
      }
      {
        showLastDate &&
        <button style={{backgroundColor: '#216ba5', borderRadius: 3, color: Colors.WHITE}} className="mt-2 ml-0 w-100" onClick={() => handleLastDate()} disabled={nextMonthButtonDisabled}>
          {"Fecha final"}
        </button>
      }
    </div>

  </div>)
}


const CalendarForm = ({width = `100%`, className = "classNameDefaultCalendar", label = "Titulo Prueba", identificador = "test", handleChange, disabled = false,
                      value = defaultValue, required = false, inputProps = null, customError = null}) => {


    return(
        <FormControl key={`key${identificador}`}  className={`my-1 ${className}`}>
          <Tooltip title={`${required ? `*${label}` : `${label}`}`}>
            <InputLabel className="calendarLabel" shrink htmlFor={identificador} style={{width, pointerEvents: "auto"}}>{`${required ? `*${label}` : `${label}`}`}</InputLabel>
          </Tooltip>
            {   !('control' in inputProps) ?
            <DatePicker
                selected={getFechaToCalendar(value) || defaultValue}
                onChange={(date) => handleChange({name: identificador, value: dateToStringFormat(date)})}
                renderCustomHeader={({...props}) => <RenderCustomHeader {...props} showLastDate={false} identificador={identificador} controller={false}/>}
                className={`mx-1 calendarClass w-100 custom_calendar`}
                style={{width, paddingLeft: 10,    boxShadow: '0 2px 5px 0 rgb(0 0 0 / 4%)'}}
                disabled={disabled}
                dateFormat="yyyy-MM-dd"
                placeholderText="Seleccione"
                autoComplete="off"
                name={identificador}
            />
            :
            <Controller
                rules={{ required: required }}
                control={inputProps.control}
                defaultValue={dateToStringFormat(new Date())}
                name={identificador}
                render={({ field: { onChange, onBlur, value } }) =>
                    (
                        <DatePicker
                            selected={getFechaToCalendar(value)}
                            onChange={(date) => onChange(dateToStringFormat(date))}
                            renderCustomHeader={({...props}) => <RenderCustomHeader {...props} showLastDate={false} identificador={identificador} controller={true}/>}
                            disabled={disabled}
                            className={`mx-1 calendarClass w-100 custom_calendar`}
                            style={{width, paddingLeft: 10,    boxShadow: '0 2px 5px 0 rgb(0 0 0 / 4%)'}}
                            onBlur={onBlur}
                            dateFormat="yyyy-MM-dd"
                            placeholderText="Seleccione"
                            autoComplete="off"
                            name={identificador}
                        />
                    )
                }
            />
        }
        {
          (!isEmpty(customError) || required) &&
            <span className="mt-1 pl-2 titleForm panelColorError">{customError}</span>
        }
        </FormControl>
    )


};

const CalendarFormController = ({required, inputProps, identificador, disabled, disabledInit, disabledFin, width}) => {

  const { field } = useController({ control: inputProps.control , name: identificador });
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const valor = useWatch({
    control: inputProps.control,
    name: identificador
  })

  useEffect(() => {
    return () => {
      Emitter.off(`handleSelectLastDateController${identificador}`);
    }
  }, [])

  useEffect(() => {
    Emitter.on(`handleSelectLastDateController${identificador}`, (date) => field.onChange([startDate, date]));
  }, [])

  useEffect(() => {

    let arrDates = validArray(valor).slice();
    let sDate = isEmpty(arrDates[0]) ? null : arrDates[0];
    let eDate = isEmpty(arrDates[1]) ? null : arrDates[1];
    setStartDate(sDate);
    setEndDate(eDate);


  }, [valor, setStartDate, setEndDate])

  return(
    <div className="d-flex px-2">
      <DatePicker
        selected={startDate}
        onChange={(date) => {
          field.onChange([date, endDate])
        }}
        selectsStart
        startDate={startDate}
        endDate={endDate}
        renderCustomHeader={({...props}) => <RenderCustomHeader {...props} showLastDate={false} identificador={identificador} controller={true}/>}
        className={`mx-1 calendarClass w-auto custom_calendar mb-0`}
        style={{width: 'auto', paddingLeft: 10, boxShadow: '0 2px 5px 0 rgb(0 0 0 / 4%)'}}
        disabled={disabled || disabledInit}
        dateFormat="yyyy-MM-dd"
        placeholderText="Seleccione"
        autoComplete="off"
        name={identificador}
      />
      <DatePicker
        selected={endDate}
        onChange={(date) => {
          field.onChange([startDate, date])
        }}
        selectsEnd
        startDate={startDate}
        endDate={endDate}
        style={{width: 'auto', paddingLeft: 10, boxShadow: '0 2px 5px 0 rgb(0 0 0 / 4%)'}}
        renderCustomHeader={({...props}) => <RenderCustomHeader {...props} showLastDate={true} identificador={identificador} controller={true}/>}
        className={`mx-1 calendarClass w-auto custom_calendar mb-0`}
        disabled={disabled || disabledFin}
        dateFormat="yyyy-MM-dd"
        placeholderText="Seleccione"
        autoComplete="off"
        name={identificador}
      />
    </div>

  )

}

const CalendarFormRange = ({
    width = `100%`, 
    className = "classNameDefaultCalendar", 
    label = "Titulo Prueba", 
    identificador = "test", 
    handleChange, 
    disabled = false,
    disabledInit = false,
    disabledFin = false,
    valueIni = defaultValue, 
    valueFin = defaultValue, 
    required = false, 
    inputProps = null, 
    customError = null 
}) => {

    const [startDate, setStartDate] = useState(valueIni);
    const [endDate, setEndDate] = useState(valueFin);

    useEffect(() => {
        return () => {
            Emitter.off(`handleSelectLastDateNoController${identificador}`);
        }
    }, [])

    useEffect(() => {
        Emitter.on(`handleSelectLastDateNoController${identificador}`, (date) => setEndDate(date));
    }, [])

    useEffect(() => {
        if(isFunction(handleChange)){
            let sDate = isEmpty(startDate) ? null : startDate;
            let eDate = isEmpty(endDate) ? null : endDate;
            handleChange({name: identificador, value: [sDate, eDate]})
        }
    }, [startDate, endDate, setStartDate, setEndDate])

    useEffect(() => {
        if(valueIni == '' && valueFin == ''){
            setStartDate('');
            setEndDate('');
        }
    }, [valueIni, valueFin])

    return(
        <FormControl key={`key${identificador}`}  className={`my-1 ${className}`}>
          <Tooltip title={`${required ? `*${label}` : `${label}`}`}>
            <InputLabel className="calendarLabel" shrink htmlFor={identificador} style={{width, pointerEvents: "auto"}}>{`${required ? `*${label}` : `${label}`}`}</InputLabel>
          </Tooltip>
            {   isObject(inputProps) && !('control' in inputProps) ?

                <div className="d-flex px-2">
                  <DatePicker
                    selected={startDate}
                    value={valueIni}
                    onChange={(value) => setStartDate(value)}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    renderCustomHeader={({...props}) => <RenderCustomHeader {...props} showLastDate={false} identificador={identificador} controller={false}/>}
                    className={`mx-1 calendarClass w-auto custom_calendar mb-0`}
                    style={{width: 'auto', paddingLeft: 10, boxShadow: '0 2px 5px 0 rgb(0 0 0 / 4%)'}}
                    disabled={disabled || disabledInit}
                    dateFormat="yyyy-MM-dd"
                    placeholderText="Seleccione"
                    autoComplete="off"
                    name={identificador}
                  />
                  <DatePicker
                    selected={endDate}
                    value={valueFin}
                    onChange={(value) => setEndDate(value)}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    style={{width: 'auto', paddingLeft: 10, boxShadow: '0 2px 5px 0 rgb(0 0 0 / 4%)'}}
                    renderCustomHeader={({...props}) => <RenderCustomHeader {...props} showLastDate={true} identificador={identificador} controller={false}/>}
                    className={`mx-1 calendarClass w-auto custom_calendar mb-0`}
                    disabled={disabled || disabledFin}
                    dateFormat="yyyy-MM-dd"
                    placeholderText="Seleccione"
                    autoComplete="off"
                    name={identificador}
                  />
                </div>
                :
                <CalendarFormController required={required} inputProps={inputProps} identificador={identificador} disabled={disabled} disabledInit={disabledInit} disabledFin={disabledFin} width={width}/>
            }
            {
              (!isEmpty(customError) || required) &&
                <span className="mt-1 pl-2 titleForm panelColorError">{customError}</span>
            }
        </FormControl>
    )

}

export {
    CalendarForm,
    CalendarFormRange,
};

